



































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {SocialType} from '@/model/resource/SocialType'
import {InputSocialTypeSchema} from '@/schema/resource/SocialType/InputSocialTypeSchema'

@Component
export default class PersistSocialTypeView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputSocialTypeSchema()
  socialType = new SocialType()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.socialType.getSocialType(id)
    }

    this.$await.done('getSocialType')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.socialType.persistSocialType()
    this.$toast.success('system.success.persist')
    await this.$nav.push('/social-type/list')
  }
}
